// extracted by mini-css-extract-plugin
module.exports = {"root":"FileDropArea_root__2PDIW"};